(() => {
    const observer = new MutationObserver(() => {
    const target = document.querySelector(`.product__thumbs`);
      if (target) {
          observer.disconnect();
          function play_video_product(){
              const element_selected = document.querySelector(`.product-main-slide.is-selected`);
              if (!element_selected) return;
              const video = element_selected.querySelector("video");
              if (element_selected.dataset.index == 1 && video) {
                video.currentTime = 0;
                video.play().catch(() => {
                  video.muted = true;
                  video.play();
                });
              }
          }
          play_video_product();

           document.querySelectorAll('.product__thumb-item').forEach(radio => {
            radio.addEventListener('click', function() {
              play_video_product()
            });
          });

          // On desktop, slide changes are mostly driven by the arrows or by
          // dragging the main image instead of clicking a thumbnail, so those
          // navigation paths never trigger the listeners above. Flickity toggles
          // the `is-selected` class on the active slide regardless of how the
          // user navigated to it, so watching for that class change catches
          // every navigation method consistently on desktop and mobile.
          const slideObserver = new MutationObserver(() => {
            play_video_product();
          });

          document.querySelectorAll('.product-main-slide').forEach(slide => {
            slideObserver.observe(slide, { attributes: true, attributeFilter: ['class'] });
          });
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
})();